import script from "./PackageAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./PackageAnalysis.vue?vue&type=style&index=0&id=c2361f5a&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2361f5a"]])

export default __exports__